export interface Partner {
    readonly name: string;
    readonly logo: string;
}

/**
 * The developers and banks whose logos the live site shows. A brand name is not translated, so this
 * is a constant rather than a pair of string-table entries.
 */
export const partners: readonly Partner[] = [
    { name: 'BI Group', logo: '/media/images/partner-icons/bi-group.png' },
    { name: 'Sat-NS', logo: '/media/images/partner-icons/sat-ns.png' },
    { name: 'NAK', logo: '/media/images/partner-icons/nak.png' },
    { name: 'Sardar Group', logo: '/media/images/partner-icons/sardar-group.png' },
    { name: 'Tumar Group', logo: '/media/images/partner-icons/tumar-group.png' },
    { name: 'Qazaq Stroy', logo: '/media/images/partner-icons/qazaq-stroy.png' },
    { name: 'Beles', logo: '/media/images/partner-icons/beles.png' },
    { name: 'ULYTAU Group', logo: '/media/images/partner-icons/ulytau-group.png' },
    { name: 'Isma Invest', logo: '/media/images/partner-icons/isma-invest.png' },
    { name: 'Akan Building', logo: '/media/images/partner-icons/akan-building.png' },
    { name: 'TEVIS GROUP', logo: '/media/images/partner-icons/tevis-group.png' },
    { name: 'ALVA', logo: '/media/images/partner-icons/alva.png' }
];
